import { createContext } from '@shared/utils/createContext';
import type { UnlockDialogOpenOptions } from './UnlockDialog.types';

type UnlockDialogContextValue = Readonly<{
  isOpen: boolean;
  handleUnlockDialogOpen: (options?: UnlockDialogOpenOptions) => void;
  onClose: () => void;
  shouldDisplayFindInvite: boolean;
  markUnlocked: () => void;
}>;

const [, useUnlockDialogContext, UnlockDialogContext] = createContext<UnlockDialogContextValue>({
  name: 'UnlockDialogContext',
  errorMessage: 'useUnlockDialogContext must be used within a UnlockDialogProvider',
});

export { UnlockDialogContext, useUnlockDialogContext };
export type { UnlockDialogContextValue };
